import React from "react";
import vanImage from "../../asset/van.jpg";

export function Transportservice() {
  return (
    <div id="transport" className="mt-5 pb-5">
      <div className="mx-5">
        <h1 className="fs-1 fw-bold font-monospace text-center mb-5">
          Transportservice
        </h1>

        <div className="d-flex justify-content-around align-items-center">
          <p className="fs-3 text-start" style={{ maxWidth: "700px" }}>
            Wir bieten schnelle und zuverlässige Transportlösungen für
            Privatpersonen und Unternehmen. Egal ob einzelne Möbelstücke,
            Geräte oder komplette Lieferungen – wir sorgen dafür, dass Ihre
            Güter sicher und termingerecht ankommen.
            <br />
            <br />
            Mit unserem modernen Fuhrpark und erfahrenen Fahrern garantieren
            wir einen reibungslosen Ablauf. Flexibilität steht bei uns an
            erster Stelle – ob kurzfristige Aufträge oder geplante Transporte.
            <br />
            <br />
            Vertrauen Sie uns Ihre Lieferung an und profitieren Sie von einem
            Service, der sich an Ihre Bedürfnisse anpasst.
          </p>

          <img
            className="responsive-img"
            style={{ maxWidth: "360px" }}
            src={vanImage}
            alt="Transport"
          />
        </div>
      </div>
    </div>
  );
}